import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';

import { apiService } from '../../constants/ApiService';
import {
  FormGroup,
  Form,
  Input,
  CardTitle,
  Label,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { FormControl } from 'react-bootstrap';



const AddUserProfileMaster = () => {

  const navigate = useNavigate()
  const location = useLocation();
  const [editMode, setEditMode] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onHandleBackClient = () => {
    navigate(-1)
  }

  const [userProfile, setUserProfile] = useState({
    id: 0,
    user_profile: "",
    save_yes_no: "yes",
    modify_yes_no: "yes",
    delete_yes_no: "yes",
    print_only: "yes",
    report_yes_no: "yes",
    view_yes_no: "yes",
    // branch_view_all: "",
    // unique_trn_id: 0,
    // client_purchaser_code: "",
    // client_purchaser_name: "",
    // agent_code: "",
    // agent_name: "",
    // company_owner_code: "",
    // company_owner_name: "",
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserProfile({ ...userProfile, [name]: value });
  };

  const handleSubmit = async () => {

    // If already submitting, do nothing
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    if (!userProfile.user_profile) {
      alert("Enter the Profile")
      setIsSubmitting(false);

      return
    }

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.post(`api/admin/User_Detail/Save_User_Pofile`, userProfile, config)
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        navigate("/userProfile")
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
       toast.error(`SomeThing went wrong!!`);
    }
    finally {
      setIsSubmitting(false); // Re-enable button
    }
  };


  const getUserProfileData = async (userId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`api/admin/User_Detail/GetUserProfileById?id=${userId}`, config)
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setUserProfile(response.user_Profile_MastersBYID)
        // toast.success(response.message);
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
       toast.error(`SomeThing went wrong!!`);
    }
  }

  useEffect(() => {
    if (location.state) {
      getUserProfileData(location.state.userId)
      setEditMode(true)
    }
  }, [location.state]);

  const updateUserprofile = async () => {
    // If already submitting, do nothing
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    if (!userProfile.user_profile) {
      alert("Enter the Profile")
      setIsSubmitting(false);

      return
    }


    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.put(`api/admin/User_Detail/UpdateUserProfileById?id=${userProfile.id}`, userProfile, config)
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
       toast.error(`SomeThing went wrong!!`);
    }
    finally {
      setIsSubmitting(false); // Re-enable button
    }
  }


  return (
    <Col>
      <Card className="shadow">
        <div>
          <CardTitle tag="h3" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <i className="bi bi-card-text mr-2"></i>
              {false ? "Edit UserProfile Detail" : "UserProfile Detail"}
            </div>
            <Button color="warning" size="bg" onClick={onHandleBackClient} className="ml-auto">
              Back
            </Button>
          </CardTitle>

          <CardBody>

            <Form >
              <Row>

                <Col md={3}>
                  <FormGroup>
                    <Label for="user_profile">User Profile</Label>
                    <Input
                      type="text"
                      name="user_profile"
                      id="user_profile"
                      value={userProfile.user_profile}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>



                <Col md={3}>
                  <FormGroup>
                    <Label for="save_yes_no">Save Yes/No</Label>
                    <Input
                      type="select"  className="custom-select"
                      name="save_yes_no"
                      id="save_yes_no"
                      value={userProfile.save_yes_no}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>

                    </Input>
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label for="modify_yes_no">Modify Yes/No</Label>
                    <Input
                      type="select"  className="custom-select"
                      name="modify_yes_no"
                      id="modify_yes_no"
                      value={userProfile.modify_yes_no}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>

                    </Input>
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label for="delete_yes_no">Delete Yes/No</Label>
                    <Input
                      type="select"  className="custom-select"
                      name="delete_yes_no"
                      id="delete_yes_no"
                      value={userProfile.delete_yes_no}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>

                    </Input>
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label for="print_only">Print Only</Label>
                    <Input
                      type="select"  className="custom-select"
                      name="print_only"
                      id="print_only"
                      value={userProfile.print_only}
                      onChange={handleChange}
                    >

                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>

                    </Input>
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label for="report_yes_no">Report Yes/No</Label>
                    <Input
                      type="select"  className="custom-select"
                      name="report_yes_no"
                      id="report_yes_no"
                      value={userProfile.report_yes_no}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>

                    </Input>
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label for="view_yes_no">View Yes/No</Label>
                    <Input
                      type="select"  className="custom-select"
                      name="view_yes_no"
                      id="view_yes_no"
                      value={userProfile.view_yes_no}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>

                    </Input>
                  </FormGroup>
                </Col>


              </Row>
              {
                editMode ?
                  <>
                    <Button color="primary" type="button" disabled={isSubmitting}
                      onClick={updateUserprofile}>
                      Update
                    </Button>
                  </>
                  :
                  <>
                    <Button color="primary" type="button" disabled={isSubmitting}
                      onClick={handleSubmit}>
                      Save
                    </Button>
                  </>
              }

            </Form>


          </CardBody>
        </div>
      </Card>
    </Col>
  )
}

export default AddUserProfileMaster



